import * as exElement from '../../../utils/element';

// ----------------------------------------------------------------------------

function hide(element: HTMLElement): void {
    exElement.hide(element);
}

// ----------------------------------------------------------------------------

export default hide;
